import { IoMdClose } from 'react-icons/io';
import { AppColors } from '../../Utils/helper/AppColors';
import { FiEdit2, FiMinus, FiPlus, FiUploadCloud } from 'react-icons/fi';
import { MdInfoOutline } from 'react-icons/md';
import { FaCircle } from 'react-icons/fa';
import { GoRocket } from 'react-icons/go';
import {IoIosRocket} from "react-icons/io"
import { BsQuestionCircle, BsToggleOn } from "react-icons/bs";
import { BsToggleOff } from "react-icons/bs";
import { LuArrowLeft } from 'react-icons/lu';
import { TbCopy } from 'react-icons/tb';
import { AiOutlineDelete } from 'react-icons/ai';
import { RiCheckFill } from 'react-icons/ri';
import { IoEarthOutline } from "react-icons/io5";
import { IoIosLink } from "react-icons/io";
import { TiInfoOutline } from "react-icons/ti";
import { FaRegEyeSlash } from "react-icons/fa6";
import { FaRegEye } from "react-icons/fa6";
import { CiClock2, CiSearch } from "react-icons/ci";
import { IoLayersOutline } from "react-icons/io5";
import { MdOutlinePeopleAlt } from "react-icons/md";
import { RiMoneyDollarCircleLine } from "react-icons/ri";

import { MdFilterList } from 'react-icons/md';
import { IoExpandSharp } from "react-icons/io5";
import { CgFileDocument } from "react-icons/cg";
import { FiAlertOctagon } from "react-icons/fi";
import { FiPlayCircle } from "react-icons/fi";

import { PiToggleRightBold } from "react-icons/pi";
import { PiToggleLeftBold } from "react-icons/pi";

import { AiOutlineUser } from "react-icons/ai";
import { SlLocationPin } from "react-icons/sl";
import { FiMail } from "react-icons/fi";
import { IoCallOutline } from "react-icons/io5";
import { IoIosArrowDown } from "react-icons/io";



import { FiEdit } from "react-icons/fi";
import { LuSend } from "react-icons/lu";
import { FaRegCheckCircle } from "react-icons/fa";
import { FaChevronRight } from "react-icons/fa6";
import { FaChevronLeft } from "react-icons/fa6";
import { FiCalendar } from "react-icons/fi";
import { LuClock8 } from "react-icons/lu";
import { GoPeople } from "react-icons/go";

import { LiaChartPieSolid } from "react-icons/lia";
import { HiOutlineChatBubbleOvalLeft } from "react-icons/hi2";

import { FiAlertTriangle } from "react-icons/fi";
import { LuLink } from "react-icons/lu";
import { RiSettings5Line } from "react-icons/ri";
import { ImStack } from "react-icons/im";

import { LuRadio } from "react-icons/lu";
import { RiDashboardFill } from "react-icons/ri";

import { FaCreditCard } from "react-icons/fa6";
import { GoGraph } from "react-icons/go";
import { BsLightningCharge } from "react-icons/bs";
import { FaArrowTrendUp } from "react-icons/fa6";
import { FaCircleDollarToSlot } from "react-icons/fa6";
import { TbRefresh } from "react-icons/tb";
import { MdArchive } from "react-icons/md";
import { MdUnarchive } from "react-icons/md";

import { LiaCloudDownloadAltSolid } from "react-icons/lia";

import { MdSecurity } from "react-icons/md";
import { MdAddIcCall } from "react-icons/md";
import { MdQrCodeScanner } from "react-icons/md";

import { FiDownload } from "react-icons/fi";

import { MdOutlineSupportAgent } from "react-icons/md";
import { MdSpaceDashboard } from "react-icons/md";



export const SpaceDashboardIcon = ({ size, color }) => {
	return <MdSpaceDashboard size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}

export const ArchiveIcon = ({ size, color }) => {
	return <MdArchive size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}

export const UnarchiveIcon = ({ size, color }) => {
	return <MdUnarchive size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}

export const RefreshIcon = ({ size, color }) => {
	return <TbRefresh size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}

export const SubscriptionIcon = ({ size, color }) => {
	return <FaCircleDollarToSlot size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}

export const ArrowTrendUpIcon = ({ size, color }) => {
	return <FaArrowTrendUp size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}

 export const CreditCardIcon = ({ size, color }) => {
	return <FaCreditCard size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}

export const GraphIcon = ({ size, color }) => {
	return <GoGraph size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}

export const LightningChargeIcon = ({ size, color }) => {
	return <BsLightningCharge size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}


export const DashboardIcon = ({ size, color }) => {
	return <RiDashboardFill size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}


export const IssuesIcon = ({ size, color }) => {
	return <LuRadio size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}

export const CampaignIcon = ({ size, color }) => {
	return <ImStack size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}

export const ConversationsIcon = ({ size, color }) => {
	return <HiOutlineChatBubbleOvalLeft size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}



export const SettingsIcon = ({ size, color }) => {
	return <RiSettings5Line size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}

export const SupportIcon = ({ size, color }) => {
	return <BsQuestionCircle size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}

export const IntegrationIcon = ({ size, color }) => {
	return <LuLink size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}

export const AlertIcon = ({ size, color }) => {
	return <FiAlertTriangle size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}

export const InsightsIcon = ({ size, color }) => {
	return <LiaChartPieSolid size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}

export const PeopleIcon = ({ size, color }) => {
	return <GoPeople size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}

export const ClockIcon = ({ size, color }) => {
	return <LuClock8 size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}

export const CalendarIcon = ({ size, color }) => {
	return <FiCalendar size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}

export const ChevronRightIcon = ({ size, color }) => {
	return <FaChevronRight size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}

export const ChevronLeftIcon = ({ size, color }) => {
	return <FaChevronLeft size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}

export const CheckCircleIcon = ({ size, color }) => {
	return <FaRegCheckCircle size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}
export const SendIcon = ({ size, color, onClick }) => {
	return <LuSend size={size || 20} color={color || AppColors.TEXT_TERTIARY} onClick={onClick} />;
}
export const ArrowDownIcon = ({ size, color }) => {
	return <IoIosArrowDown size={size || 20} color={color || AppColors.TEXT_TERTIARY} />;
}
export const EditIcon2 = ({ size, color, onClick }) => {
	return <FiEdit size={size || 20} color={color || AppColors.TEXT_TERTIARY} onClick={onClick} />;
}

export const AddIcon = ({ size, color, onClick }) => {
	return <FiPlus size={size || 20} color={color || AppColors.TEXT_TERTIARY} onClick={onClick} />;
};

export const SubstractIcon = ({ size, color, onClick }) => {
	return <FiMinus size={size || 20} color={color || AppColors.TEXT_TERTIARY} onClick={onClick} />;
};

export const BackIcon = ({ size, color, onClick }) => {
	return <LuArrowLeft size={size || 20} color={color || AppColors.TEXT_PRIMARY} onClick={onClick} />;
};

export const UploadIcon = ({ size, color, onClick }) => {
	return <FiUploadCloud size={size || 20} color={color || AppColors.TEXT_TERTIARY} onClick={onClick} />;
};

export const CloseIcon = ({ size, color, onClick }) => {
	return <IoMdClose cursor="pointer" size={size || 20} color={color || AppColors.TEXT_TERTIARY} onClick={onClick} />;
};

export const EditIcon = ({ size, color, onClick }) => {
	return <FiEdit2 cursor="pointer" size={size || 18} color={color || AppColors.TEXT_TERTIARY} onClick={onClick} />;
};
export const DeleteIcon = ({ size, color, onClick }) => {
	return <AiOutlineDelete cursor="pointer" size={size || 20} color={color || AppColors.TEXT_TERTIARY} onClick={onClick} />;
};

export const InfoIcon = ({ size, color, onClick }) => {
	return <MdInfoOutline cursor="pointer" size={size || 16} color={color || AppColors.DARK_GREY} onClick={onClick} />;
};

export const DotIcon = ({ size, color }) => {
	return <FaCircle size={size || 10} color={color} />;
};

export const RocketIcon = ({ size, color }) => {
	return <IoIosRocket size={size || 20} color={color} />;
};

export const ToggleOffIcon = ({ size, color }) => {
	return <BsToggleOff size={size || 20} color={color} />;
};

export const BsToggleOnIcon = ({ size, color }) => {
	return <BsToggleOn  size={size || 20} color={color} />;
};

export const PiToggleRightBoldIcon = ({ size, color }) => {
	return <PiToggleRightBold size={size || 20} color={color} />;
};
export const PiToggleLeftBoldIcon = ({ size, color }) => {
	return <PiToggleLeftBold size={size || 20} color={color} />;
}

export const CopyIcon = ({ size, color }) => {
	return <TbCopy size={size || 18} color={color || AppColors.DARK_GREY} />;
};
export const CheckIcon = ({ size, color, onClick }) => {
	return <RiCheckFill cursor="pointer" size={size || 22} color={color || AppColors.TEXT_TERTIARY} onClick={onClick} />;
};

export const EarthIcon = ({ size, color }) => {
	return <IoEarthOutline size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
};

export const IosLink = ({ size, color }) => {
	return <IoIosLink size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
};

export const InfoOutlineIcon = ({ size, color }) => {
	return <TiInfoOutline size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
};

export const EyeSlashIcon = ({ size, color }) => {
	return <FaRegEyeSlash size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
};

export const EyeIcon = ({ size, color , onClick }) => {
	return <FaRegEye size={size || 22} color={color || AppColors.TEXT_TERTIARY} onClick={onClick} />;
};


export const AccessTimeIcon = ({ size, color }) => {
	return <CiClock2 size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
};

export const LayersIcon = ({ size, color }) => {
	return <IoLayersOutline size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
};

export const GroupsIcon = ({ size, color }) => {
	return <MdOutlinePeopleAlt size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
};

export const AttachMoneyIcon = ({ size, color }) => {
	return <RiMoneyDollarCircleLine size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
};

export const SearchIcon = ({ size, color }) => {
	return <CiSearch size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
};

export const FilterListIcon = ({ size, color }) => {
	return <MdFilterList size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
};

export const ExpandIcon = ({ size, color }) => {
	return <IoExpandSharp height={size || 22} width={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
};

export const DocumentIcon = ({ size, color }) => {
	return <CgFileDocument size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
};

export const AlertOctagonIcon = ({ size, color }) => {
	return <FiAlertOctagon size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
}

export const PlayCircleIcon = ({ size, color, onClick ,  }) => {
	return <FiPlayCircle size={size || 22} color={color || AppColors.TEXT_TERTIARY} onClick={onClick} />;
}

export const UserIcon = ({ size, color }) => {
	return <AiOutlineUser size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
};

export const LocationPinIcon = ({ size, color }) => {
	return <SlLocationPin size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
};

export const MailIcon = ({ size, color }) => {
	return <FiMail size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
};

export const CallIcon = ({ size, color }) => {
	return <IoCallOutline size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
};

export const CloudDownloadIcon = ({ size, color }) => {
	return <LiaCloudDownloadAltSolid size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
};


export const SecurityIcon = ({ size, color }) => {
	return <MdSecurity size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
};

export const InboundCallIcon = ({ size, color }) => {
	return <MdAddIcCall size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
};

export const QrCodeScannerIcon = ({ size, color }) => {
	return <MdQrCodeScanner size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
};

export const DownloadIcon = ({ size, color }) => {
	return <FiDownload size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
}

export const SupportAgentIcon = ({ size, color }) => {
	return <MdOutlineSupportAgent size={size || 22} color={color || AppColors.TEXT_TERTIARY} />;
}